var DynamicActionType;
(function (DynamicActionType) {
    DynamicActionType["CONTEXT_MENU"] = "context-menu";
    DynamicActionType["LINK"] = "link";
})(DynamicActionType || (DynamicActionType = {}));
export { DynamicActionType, };
//# sourceMappingURL=dynamic-actions-constants.js.map